module.exports = __webpack_public_path__ + "img/placeholder.2a140da2.png";